import * as React from 'react';
import { ROUTE_DISPLAY_ADJUSTED_CASH_DOWN_BREAKDOWN } from './actions/actionTypes';
import { formatType } from '../../utils/formatUtils';
import { GroupLineItemUI, LineItemUI } from './LineItemUI';

const getLabel = (description, key, labels) => {
    switch (description) {
        case 'Advertised Price':
            return labels.advertisedPriceLabel;
        case 'Specials':
            return labels.specialsLabel;
        case 'Out of Pocket':
            // Two fields have the same description, but the first one has a different key
            return key === 'downPaymentNegative' ? labels.downPaymentLabel : labels.downPaymentLabelSecond ;
        case 'Due At Signing':
            return labels.dueAtSigningLabel;
        default:
            return description;
    }
};

export interface IDealSummaryItem {
    defaultValue?: string;
    description: string;
    displayProperties: string[];
    items: any[];
    key: string;
    value: number;
}

export interface IServicesSummaryProps {
    advertisedPriceLabel?: string;
    dealSummary: IDealSummaryItem[];
    onAdjustedCashInfoClick?: { (route): void };
    specialsLabel?: string;
    downPaymentText?: string;
    downPaymentTextSecond?: string;
    dueAtSigningText?: string;
}

const ServicesSummaryUI: React.ComponentType<IServicesSummaryProps> = (props) => {
    const {
        dealSummary,
        onAdjustedCashInfoClick,
        specialsLabel,
        advertisedPriceLabel,
        downPaymentText: downPaymentLabel,
        downPaymentTextSecond: downPaymentLabelSecond,
        dueAtSigningText: dueAtSigningLabel
    } = props;
    const labels = { specialsLabel, advertisedPriceLabel, downPaymentLabel, downPaymentLabelSecond, dueAtSigningLabel };
    return (
        <div className="dr-ui-summary-container">
            <div className="summary-column">
                {dealSummary &&
                    dealSummary.map((item, index) => {
                        const notAvailableText = item.defaultValue ? item.defaultValue : '';
                        const lineItemLabel = getLabel(item.description, item.key, labels);
                        const formattedValue =
                            item.displayProperties.indexOf('negative') > -1 ? `-${formatType(item)}` : formatType(item);

                        if (item.displayProperties.indexOf('important') > -1) {
                            return (
                                <GroupLineItemUI
                                    key={index}
                                    label={lineItemLabel}
                                    notAvailableText={item.defaultValue}
                                    id={item['key']}
                                    showSeparator={false}
                                    value={formatType(item)}
                                />
                            );
                        }

                        if (item.displayProperties.indexOf('separator') > -1) {
                            return <hr key={index} />;
                        }

                        return (
                            <LineItemUI
                                id={item['key']}
                                key={index}
                                label={lineItemLabel}
                                notAvailableText={notAvailableText}
                                onClickEvent={() => onAdjustedCashInfoClick(ROUTE_DISPLAY_ADJUSTED_CASH_DOWN_BREAKDOWN)}
                                value={formattedValue}
                            />
                        );
                    })}
            </div>
        </div>
    );
};

export default ServicesSummaryUI;
